import { render, staticRenderFns } from "./TrendNavigation.vue?vue&type=template&id=6cf81936&scoped=true&name=trend-navigation&"
import script from "./TrendNavigation.vue?vue&type=script&lang=js&"
export * from "./TrendNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TrendNavigation.vue?vue&type=style&index=0&id=6cf81936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf81936",
  null
  
)

export default component.exports